import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withToastManager } from "react-toast-notifications";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { Translate, I18n } from "react-redux-i18n";
import { getXsrfToken } from "../../Store/Security/Actions";
import { addToCart as addToNopCommerceCart, updateTempCart, updateTempCartKitUI, updateTempWirelessPlan } from "../../Store/Cart/Actions";
import { goNext, onFinish } from "../../Store/Wizard/Actions";
import RadioButtons from "./RadioButtons";
import Modal from "react-modal";

class WirelessPlan extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quantity: 1,
            optionClicked: {},
            modalIsOpen: false
        };

        this.addToCart = this.addToCart.bind(this);
        this.selectOption = this.selectOption.bind(this);
        this.openNoDataModal = this.openNoDataModal.bind(this);
        this.closeNoDataModal = this.closeNoDataModal.bind(this);
    }

    componentDidMount() {
        const { selectedOption, selectedPlanId } = this.props;

        $(".wireless-plan-message").show();

        // when going back to the wireless step of build kit, this will get the selected option from the step and retain it
        if (selectedOption > -1 && selectedOption !== null) {

            let selectedRadiobutton = $("#wireless-price-" + selectedPlanId).find(".radio")[selectedOption];
            let inputOfSelectedRadio = selectedRadiobutton.getElementsByTagName("input");

            $(inputOfSelectedRadio[0]).click();

            // remove disable class from Select Plan button once a selection is made from radio list
            $(".wireless-btn-" + selectedPlanId).removeClass("disabled-button");

            // remove button tool tip once a selection is made from radio list
            $(".tooltip-wrapper-" + selectedPlanId).removeAttr("data-tooltip");
        }
    }

    selectOption(optionClicked) {
        const { updateTempWirelessPlan } = this.props;

        this.setState({ optionClicked });
        updateTempWirelessPlan(optionClicked);
    }

    addToCart() {
        const { getXsrfToken, product, wizards, goNext, onFinish, addToNopCommerceCart, updateTempCart, updateTempCartKitUI, wizard, wizardName, deviceQuantity, filter: title, kitQuantity, closePlanModal, toastManager, selectedDeviceId } = this.props;
        const { optionClicked } = this.state;

        this.closeNoDataModal();

        if (wizard) {
            let quantity = wizardName === "Devices" ? deviceQuantity : kitQuantity;
            updateTempCart({ [title]: { [product.id]: { ...product, quantity: quantity, ...optionClicked } } });
            if (wizardName === "KitsBuild") {
                updateTempCartKitUI({ [title]: { [product.id]: { ...product, quantity: quantity, ...optionClicked } } });
            }

            const { totalSteps, currentStep } = wizards[wizardName];

            // Wizard is finished at the second to last step because the last step is the Cart
            if (currentStep === totalSteps - 1) {
                onFinish(wizardName);
            } else {
                goNext(wizardName);
            }

            window.scrollTo(0, 0);
        } else {
            toastManager.add(I18n.t("alerts.addedToCart", { quantity: deviceQuantity, name: product.name }), {
                appearance: "success",
                autoDismiss: true,
                icon: faShoppingCart
            });

            getXsrfToken(({ token }) => {
                const item = {
                    ProductId: product.id,
                    Quantity: deviceQuantity
                };

                if (selectedDeviceId > 0) {
                    item.KitId = selectedDeviceId;
                }

                if (optionClicked.productAttributeId) {
                    item.AttributeControlIds = [`product_attribute_${product.id}_${optionClicked.productAttributeId}_${optionClicked.productAttributeMapId}_${optionClicked.attributeValueId}`];
                }

                addToNopCommerceCart({
                    items: [item],
                    __RequestVerificationToken: token
                });
            });
            
            closePlanModal();
        }

    }

    openNoDataModal() {
        this.setState({modalIsOpen: true});
    }

    closeNoDataModal() {
        this.setState({modalIsOpen: false});
    }

    render() {
        const { product, productAttributes, price, discountPrice, title, image } = this.props;
        const { modalIsOpen } = this.state;

        return (
            <div className="masonry__item col-md-12 col-lg-6 col-xl-4 wireless-columns">
                <div className="pricing pricing-1 boxed boxed--lg boxed--border wireless-plans-container h-100 d-flex flex-column">
                    { productAttributes && productAttributes.length > 0 && productAttributes[0].name === I18n.t("attributes.rogersDataPlans")
                        ?
                        <p className="canada-only-text">(<Translate value="dataPlans.canadaOnly" />)</p>
                        :
                        <div></div>
                    }

                    <h3 className="wireless-plan-title">{title}</h3>
                    <div className="product-image">
                        <img alt="Image" src={image} />
                    </div>

                    {/*{ productAttributes && productAttributes.length > 0 && productAttributes[0].name !== I18n.t("attributes.rogersDataPlans")
                        ? <span className="type--fine-print"><Translate value="dataPlans.overage1" /></span>
                        : productAttributes[0] && productAttributes[0].name === I18n.t("attributes.rogersDataPlans")
                            ? <span className="type--fine-print"><Translate value="dataPlans.overage2" /></span>
                            : <div></div>
                    }*/}

                    <hr></hr>

                    <div className="wireless-price" id={`wireless-price-${product.id}`}>
                        {/* Show dropdown on products with attribute options, else just show price */}
                        { productAttributes && productAttributes.length > 0 ?
                            <div>
                                <form>
                                    <RadioButtons productAttribute={productAttributes[0]} product={product} selectOption={this.selectOption} />
                                </form>
                            </div>
                            :
                            <span className="h2"><strong>{price}</strong></span>
                        }
                    </div>

                    {/* disable Select Plan on dropdown products until a selection is made, else always active */}
                    { productAttributes && productAttributes.length > 0 ?
                        <div className={`tooltip-wrapper-${product.id} wireless-button-container`} data-tooltip={I18n.t("dataPlans.tooltip")}>
                            <a className={`btn btn--primary wireless-btn-${product.id} wireless-plan-button disabled-button`} onClick={this.addToCart}>
                                <span className="btn__text">
                                    <Translate value="dataPlans.select" />
                                </span>
                            </a>
                        </div>
                        :
                        <div>
                            <a className={"btn btn--primary"} onClick={this.openNoDataModal}>
                                <span className="btn__text">
                                    <Translate value="dataPlans.select" />
                                </span>
                            </a>
                            <Modal
                                isOpen={modalIsOpen}
                                onRequestClose={this.closeNoDataModal}
                                contentLabel={"No Data Plan alert"}
                                className="modal-content"
                                overlayClassName="modal-container create-account-modal modal-active"
                            >
                                <div className="modal-body">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12 text-center">
                                            <div className="feature feature-1">
                                                <div className="text-block">
                                                    <h3><Translate value="dataPlans.modalTitle"/></h3>
                                                    <p><Translate value="dataPlans.modalText"/></p>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 text-center">
                                                        <button className="btn btn--primary type--uppercase" type="button" onClick={this.closeNoDataModal} style={{ width: 150 }}><Translate value="dataPlans.modalCancel"/></button>
                                                    </div>
                                                    <div className="col-md-6 text-center">
                                                        <button className="btn btn--primary type--uppercase" type="button" onClick={this.addToCart} style={{ width: 150 }}><Translate value="dataPlans.modalContinue"/></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        wizards: state.wizards,
        kitQuantity: state.kitQuantity,
        deviceQuantity: state.deviceQuantity
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        addToNopCommerceCart: addToNopCommerceCart,
        updateTempCart: updateTempCart,
        updateTempCartKitUI: updateTempCartKitUI,
        updateTempWirelessPlan: updateTempWirelessPlan,
        goNext: goNext,
        onFinish: onFinish
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(WirelessPlan));